import { LOCALE } from 'src/dataLayer/env'

import { reportTrackerFailure } from '../rollbar'
import emitEvent from './emitEvent'
import { validateEventProps as validateEventProperties } from './validateEventProps'

export default ({ getCalltimePayload, name, version }) =>
  (payload) => {
    const { learnLanguageCode } = payload
    validateEventProperties({
      learnLanguageCode,
      locale: LOCALE,
      name,
      version,
      ...payload,
    })

    return emitEvent({
      error: (error) => reportTrackerFailure(error, name, payload),
      name,
      payload: {
        learn_language_alpha3: learnLanguageCode,
        locale: LOCALE,
        ...getCalltimePayload(payload),
      },
      version,
    })
  }
